import React from 'react'
import { TemplateObject } from '../../Models/TemplateObject'

type Props = {
    buttonProps: TemplateObject,
    clickHandler?: React.MouseEventHandler<HTMLButtonElement>
}

const ButtonComponent = ({ buttonProps, clickHandler }: Props) => {
    return (
        <button
            className={buttonProps.className}
            id={buttonProps.id}
            style={buttonProps.style}
            onClick={clickHandler}
            disabled={buttonProps.disabled}
        >
            {buttonProps.text+" "}
            {buttonProps.icon?buttonProps.icon:""}
        </button>
    )
}

export default ButtonComponent
